import React from 'react'
import { makeStyles, createStyles, useMediaQuery, Box } from '@material-ui/core/'
import { Route, Switch, useLocation, useHistory } from 'react-router-dom'
import { baseRoutes, authRoutes, userRoutes } from './routesConfig'
import classnames from 'classnames'
import NoFound from 'src/pages/404'
import MobileNoFound from 'src/mobile/pages/404'
import MobileErrorStatus from 'src/mobile/components/ErrorStatus'
import ProfileSidebar from 'src/layout/ProfileSidebar'
import { MOBILE_HEADER_HEIGHT, FOOTER_HEIGHT } from 'src/utils/constant'
import Layout from 'src/layout/Layout'
import SidebarContentHeader from 'src/layout/SidebarContentHeader'
import MobileHeader from 'src/mobile/layout/Header'
import MobileFooter from '../mobile/components/Footer'
import MobileFooterBottom from '../mobile/components/FooterBottom'
import MobileLayout from 'src/mobile/layout'
import PCFooter from 'src/layout/Footer'
import PCFooterBottom from 'src/layout/FooterBottom'
import TemAuthRedirect from 'src/pages/auth/TemAuthRedirect'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      fontFamily: 'Inter',
      position: 'relative',
      minHeight: `calc(100vh - ${theme.spacing(FOOTER_HEIGHT)}px)`,
      '& .MuiButtonBase-root': {
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
    button: {
      marginBottom: theme.spacing(1.75),
    },
    content: {
      flexGrow: 1,
      padding: 0,
      marginTop: theme.spacing(10),
      paddingTop: theme.spacing(1),
      // paddingBottom: theme.spacing(8),
      [theme.breakpoints.down('xs')]: {
        paddingTop: theme.spacing(MOBILE_HEADER_HEIGHT + 12),
      },
    },
    sidebarContent: {
      marginLeft: '270px',
      borderLeft: '1px solid #E5E7EB',
      paddingLeft: theme.spacing(5),
      [theme.breakpoints.down('md')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
      [theme.breakpoints.down('xs')]: {
        paddingTop: theme.spacing(MOBILE_HEADER_HEIGHT),
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    userRoutesContent: {
      display: 'flex',
      margin: theme.spacing(0, 5.5),
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(0, 0),
      },
      [theme.breakpoints.down('xs')]: {
        margin: theme.spacing(0, 2),
      },
    },
    mobileMain: {
      position: 'relative',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
    },
  }),
)

const AppRouter = () => {
  const classes = useStyles()
  const { pathname } = useLocation()
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('xs'), { noSsr: true })
  // const hideFooter = ['/doctor', '/clinic', '/profile/order'].find((path) =>
  //   matchPath(pathname, { path: path, exact: true }),
  // )
  const { i18n } = useTranslation()
  const history = useHistory()

  const languageCodeRegex = /^(\/en|\/zh-HK|\/zh-CN)/
  const match = pathname.match(languageCodeRegex)
  const languagePrefixes = match ? match[0] : null
  const urlLang = languagePrefixes && languagePrefixes.startsWith('/') ? languagePrefixes.slice(1) : null

  if (urlLang && urlLang !== i18n.language) {
    i18n.changeLanguage(urlLang)
  }
  if (!languagePrefixes) {
    history.replace(`/${i18n.language || 'zh-HK'}${pathname}`)
  }

  return isMobile ? (
    <MobileLayout>
      <Switch>
        {baseRoutes.concat(...userRoutes, ...authRoutes).map((route, i) => (
          <Route
            exact={!route.exact}
            path={route.path}
            key={i}
            component={() => (
              <Box
                className={classes.mobileMain}
                bgcolor={route.bgColor || 'background.paper'}
                component="main"
              >
                <Switch>
                  <Route exact path="/:lang(en|zh-HK|zh-CN)/add-order/paying/:orderNumber">
                    <MobileHeader
                      header={{
                        title: 'glossary.appointment_process_list.3',
                        goHome: true,
                      }}
                    />
                  </Route>
                  <Route exact path="/:lang(en|zh-HK|zh-CN)/add-order/success/:orderNumber">
                    <MobileHeader
                      header={{
                        title: 'glossary.appointment_process_list.4',
                        goHome: true,
                      }}
                    />
                  </Route>
                  <Route exact path="/:lang(en|zh-HK|zh-CN)/add-order/paying/">
                    <MobileHeader
                      header={{
                        title: 'glossary.appointment_process_list.5',
                        goBack: true,
                      }}
                    />
                  </Route>
                  <Route path="*">
                    <MobileHeader header={route.header} />
                  </Route>
                </Switch>
                <MobileErrorStatus />
                <route.mobileComponent />
                {route.footer ? <MobileFooter /> : ''}
                {route.footerBottom ? <MobileFooterBottom /> : ''}
              </Box>
            )}
          />
        ))}
        <Route
          path="*"
          component={() => (
            <Box className={classes.mobileMain} component="main">
              <MobileHeader
                header={{
                  goHome: true,
                }}
              />
              <MobileNoFound />
            </Box>
          )}
        />
      </Switch>
    </MobileLayout>
  ) : (
    <Layout>
      <Box className={classes.root}>
        <Switch>
          {baseRoutes
            // .concat(...userRoutes, ...authRoutes)
            .map((route, i) => (
              <Route
                exact={!route.exact}
                path={route.path}
                key={i}
                component={() => (
                  <main className={classes.content}>
                    <route.component />
                    {route.footer ? <PCFooter /> : ''}
                    {route.footerBottom ? <PCFooterBottom /> : ''}
                  </main>
                )}
              />
            ))}
          {userRoutes.map((route, i) => (
            <Route
              exact={!route.exact}
              path={route.path}
              key={i}
              component={() => (
                <Box>
                  {route.sideBar ? (
                    <Box className={classes.userRoutesContent}>
                      <ProfileSidebar />
                      <main className={classnames(classes.content, classes.sidebarContent)}>
                        <SidebarContentHeader {...route} />
                        <route.component />
                      </main>
                    </Box>
                  ) : (
                    <route.component />
                  )}
                  <Box>
                    {route.footer ? <PCFooter /> : ''}
                    {route.footerBottom ? <PCFooterBottom /> : ''}
                  </Box>
                </Box>
              )}
            />
          ))}
          {authRoutes.map((route, i) => (
            <Route
              exact={!route.exact}
              path={route.path}
              key={i}
              component={() => (
                <main className={classes.content}>
                  <TemAuthRedirect />
                  <route.component />
                </main>
              )}
            />
          ))}
          <Route
            path="*"
            component={() => (
              <main className={classes.content}>
                <NoFound />
              </main>
            )}
          />
        </Switch>
      </Box>
    </Layout>
  )
}

export default AppRouter
